import { render, staticRenderFns } from "./languageList.vue?vue&type=template&id=2ade21f4&"
import script from "./languageList.vue?vue&type=script&lang=js&"
export * from "./languageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports